let containerEl = null;

function getContainer() {
    if (containerEl && document.body.contains(containerEl)) return containerEl;
    containerEl = document.createElement('div');
    containerEl.id = 'vs-notification-container';
    containerEl.style.cssText = 'position:fixed;top:15px;right:15px;z-index:99999;display:flex;flex-direction:column;gap:10px;max-width:380px;';
    document.body.appendChild(containerEl);
    return containerEl;
}

const COLORS = {
    success: { bg: '#d4edda', border: '#c3e6cb', text: '#155724' },
    danger:  { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24' },
    warning: { bg: '#fff3cd', border: '#ffeeba', text: '#856404' },
    info:    { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460' },
};

export function sendNotification(_title, _message, _color) {
    const colors = COLORS[_color] || COLORS.info;
    const container = getContainer();

    // Callers that read the message straight off an API response can pass undefined
    // when the endpoint omitted `message` — template literals then stringify undefined
    // to the literal text "undefined" (e.g. "Success Message 👍undefined").
    const safeMessage = (_message == null) ? '' : String(_message);

    const toast = document.createElement('div');
    toast.style.cssText = `
        background:${colors.bg};border:1px solid ${colors.border};color:${colors.text};
        padding:12px 16px;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.15);
        font-size:14px;line-height:1.4;opacity:0;transition:opacity 0.3s ease;
        cursor:pointer;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
    `;
    toast.innerHTML = `<strong style="display:block;margin-bottom:2px">${_title}</strong>${safeMessage}`;
    toast.onclick = () => removeToast(toast);

    container.appendChild(toast);
    requestAnimationFrame(() => { toast.style.opacity = '1'; });

    setTimeout(() => removeToast(toast), 5000);
}

function removeToast(toast) {
    toast.style.opacity = '0';
    setTimeout(() => { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
}
